module.exports = __webpack_public_path__ + "static/media/19_r_stena_82.81_0.97be7473.png";